import { render, staticRenderFns } from "./SearchServices.vue?vue&type=template&id=ac905582&"
import script from "./SearchServices.vue?vue&type=script&lang=js&"
export * from "./SearchServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports